var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"headline"},[_vm._v("Usuários")]),_c('user-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }